function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import App from 'modules/App';
import { DATA_SOURCES_TYPE_NAME } from '../constants';
import * as selectors from '../selectors';
import messages from '../messages';
import styles from './ExternalDataSource/ExternalDataSource.pcss';
const ContourCloudInfo = ()=>{
    useStyles(styles);
    const externalDataSources = useSelector(selectors.dataSources);
    const connectedDataSources = useSelector(selectors.connectedDataSources);
    const localizationResources = useSelector(App.selectors.localizationResources);
    const ccDataSource = externalDataSources.find((eds)=>eds.dataSourceProvider === DATA_SOURCES_TYPE_NAME.CONTOUR_CLOUD);
    if (!ccDataSource) return null;
    const ccConnectedDataSource = connectedDataSources.find((cds)=>cds.externalDataSourceId === ccDataSource.externalDataSourceId);
    if (!ccConnectedDataSource) return null;
    const { dataSourceProvider, nameKey, logo } = ccDataSource;
    const name = get(localizationResources, [
        nameKey,
        'value'
    ], dataSourceProvider);
    return /*#__PURE__*/ _jsx("div", {
        className: `${styles.dataSource} ${styles['dataSource--standalone']}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: logo,
                        name: name,
                        className: styles.dataSource__logo,
                        imgClassName: styles.dataSource__logo__img,
                        initialsClassName: styles.dataSource__logo__initials
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: `row align-items-center ${styles.dataSource__headerRow}`,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: styles.dataSource__name,
                                        children: name
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: styles.dataSource__info,
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dataSourcesInfos.ContourCloudDefault))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-auto d-flex flex-nowrap",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "tag tag--success",
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.tags.connected))
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
export default ContourCloudInfo;
